var getFormDataFromAssignment = function (_a) {
    var assignment = _a.assignment, formInfo = _a.formInfo, singleStudentId = _a.singleStudentId;
    var skills = assignment.cards.map(function (el) {
        return formInfo.flatSkills.find(function (skill) {
            return skill.id === el.data.skillId && skill.category === el.data.category;
        });
    });
    var grade = formInfo.grades.find(function (el) { var _a; return el.id === ((_a = skills[0]) === null || _a === void 0 ? void 0 : _a.gradeId); });
    var domain = grade === null || grade === void 0 ? void 0 : grade.domains.find(function (el) { var _a; return el.id === ((_a = skills[0]) === null || _a === void 0 ? void 0 : _a.domainId); });
    return {
        students: singleStudentId
            ? formInfo.students.filter(function (el) {
                return el.id === singleStudentId &&
                    (el.ptCompletion || formInfo.skipAssessments);
            })
            : formInfo.students.filter(function (el) {
                return assignment.students.some(function (it) { return it.id === el.id; });
            }),
        skills: skills,
        grade: grade,
        domain: domain,
        duration: assignment.duration,
        dates: undefined,
        name: undefined,
        cards: assignment.cards,
    };
};
export { getFormDataFromAssignment };
